import { Component, OnInit, Input, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { LU_Keyword } from '../models/keyword';
import { DataDisplayerBase } from '../data-displayer-base';
import { GalleryTypeService } from '../services/gallery-type.service';
import { TrackByUID } from 'starbase-launcher';
import { KeywordDataService } from '../services/keyword-data.service';
import { BreakpointService } from '../breakpoint.service';

@Component({
  selector: 'app-keywords-display',
  templateUrl: './keywords-display.component.html',
  styleUrls: ['./keywords-display.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class KeywordsDisplayComponent extends DataDisplayerBase<LU_Keyword> implements OnInit {

  @Input() searchText: string;
  @Input() fontSizeProxy = '1.25'; // rem
  @Output() changePageEmitter = new EventEmitter<LU_Keyword>();
  @Output() deleteMeEmitter = new EventEmitter<LU_Keyword>(); // proxy

  public filteredText: string;
  public filters: LU_Keyword[] = []; // the list of keywords which are not apart of this Image however were used in a search to find it
  public trackByUID = TrackByUID;
  public isHandset = false;
  private _subscription;

  constructor(private gallerySvc: GalleryTypeService, protected keywordSvc: KeywordDataService, private breakpointSvc: BreakpointService) {
    super();
  }

  public get keywordsAndFilters(): LU_Keyword[] {
    return [...this.data, ...this.filters];
  }

  public keywordInsideFilterList(uid: number) {
    for (const kw of this.filters) {
      if (kw.uid === uid) {
        return true;
      }
    }

    return false;
  }

  ngOnInit() {
    this._subscription = this.breakpointSvc.handset$.subscribe(
      isHandset => {
        this.isHandset = isHandset;
      }
    );

    if (this.searchText) {
      this.searchText = this.searchText.toLowerCase();
    }
    this.filteredText = this.gallerySvc.getCurrentLibraryFilters().getFiltersSetByProperty('ImageKeywords.LU_KeywordUID')[1];
    if (this.filteredText) {
     this.filteredText = this.filteredText.toLowerCase();
      // One of these may not be apart of the keywords for this image thus it was used as a filter to find this record.
      const uids = this.filteredText.split('|').map(uid => +uid);

      if (uids.length > 1) {
        const filters = uids.slice(1);
        const keywordUIDs = this.data.map(x => x.uid);
        const usedInFilterKeywords: number[] = [];

          for (const filter of filters) {
            const children = this.keywordSvc.getAllChildrenUIDs(filter);
            const synonyms = this.keywordSvc.getKeywordSynonyms(filter).map(x => x.uid);
            const combined = [...children, ...synonyms];

            const matchesFilter = combined.filter(x => keywordUIDs.includes(x));

            if (matchesFilter.length > 0) {
              usedInFilterKeywords.push(filter);
            }
          }

          this.filters = usedInFilterKeywords.map(uid => this.keywordSvc.getKeyword(uid));
        }
    }
  }
}
